// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","masterPlanPage":"master-plan-portal-page_masterPlanPage__m+gAi","help":"master-plan-portal-page_help__3Z2c-"};